
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';

  @Component({
    name: 'CarHealthIssuesHeader',
    components: {
    }
  })
  export default class CarHealthIssuesHeader extends Vue {
    @Prop()
    private text: string;

    @Prop()
    private iconFillUrl: string;
  }
